<template>
    <div>
        <font-awesome-icon 
        v-if="order === 'asc'" 
        icon="fa-solid fa-arrow-up-short-wide" 
        class="sort-icon"/>
        <font-awesome-icon 
        v-else 
        icon="fa-solid fa-arrow-down-short-wide" 
        class="sort-icon"/>
    </div>
</template>

<script>
export default {
    props: {
        order: {
            type: String,
            required: true,
        },
    },
};
</script>

<style >
.sort-icon {
  font-size: 0.75rem;
  color: #0073ff;
  vertical-align: middle;
  cursor: pointer;
}
.sort-icon:hover {
  color: #0056b3;
}
</style>